module.exports = __webpack_public_path__ + "img/18 mucho.a8bda40c.jpg";